<template>
  <div>
    <span @click="downloadExcel">
      <slot></slot>
    </span>
    <div class="open-by-check" v-if="Authorization.authenticationInfoDTO">
      <el-dialog
        title="提示"
        :visible.sync="checkVisible"
        width="432px"
        class="open-by-check"
        :show-close="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        @close="checkVisible = false">
        <!-- <p>您还不能下单，请先完成以下流程：</p>
        <span>{{tips}}</span> -->
        <div slot="title"
          class="header-row">
          <div class="title">提示</div>
        </div>
        <template>
          <div class="hint">您还不能下载报价表，请先完成以下流程：</div>
          <div class="step-row"  v-if="Authorization.authenticationInfoDTO.state === -1 || Authorization.authenticationInfoDTO.state === 2">
            <template v-if="!Authorization.authenticationInfoDTO.type || Authorization.authenticationInfoDTO.type == -1">
              选择身份（销售代理/分销大使/省代/产业带加盟商）入驻并
            </template>
            实名认证
          </div>
          <div class="step-row"  v-else-if="Authorization.authenticationInfoDTO.state === 1">
            实名认证审核 （<span style="color: #FF4D01">实名认证审核中，请耐心等待。如有疑问请联系平台客服</span>）
          </div>
          <span slot="footer" class="footer-row">
            <el-button type="primary" class="btn-confirm" @click="checkVisible = false">取消</el-button>
            <el-button type="primary" v-if="Authorization.authenticationInfoDTO.state === -1 || Authorization.authenticationInfoDTO.state === 2" class="btn-confirm" @click="enterForAuth">去认证</el-button>
          </span>
        </template>
      </el-dialog>
      </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import {sendCustomerOperationRecord} from "@/assets/js/utils";
export default {
  props: {
    loading: Boolean
  },
  data() {
    return {
      checkVisible: false,
    }
  },
  computed: {
    ...mapState(["Authorization"])
  },
  methods: {
    handleDownload() {
      this.axios.post('/fbaPriceReportCreateLog/getFbaPriceReportInfo')
      .then(res => {
        console.log(res.data.data)
        const result = res.data.data

        let a = document.createElement("a")
        a.setAttribute("href", result.reportUrl.replace('http:', location.protocol))
        a.setAttribute("target", "_blank")
        a.click()
        this.setLog(result.id)
        this.$emit('hideLoading')
      })
      .catch(() => {
        this.$emit('hideLoading')
      })
    },
    setLog(reportId) {
      const data = {
        downloadChannel: 'WEB',
        downloadCustomerId: this.Authorization.customerid,
        downloadUserId: this.Authorization.userId,
        reportId
      }
      this.axios.post('/fbaPriceReportDownloadLog/saveFbaPriceReportDownloadLog', data)
      .then(res => {
        console.log(res.data.data)
      })
      .catch(() => {})
    },
    enterForAuth() {
      this.$router.push({
        path:"/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
      });
    },
    async downloadExcel() {
      this.$emit('showLoading')
      sendCustomerOperationRecord("下载报价表")
      console.log(this.loading)
      if (this.loading) return false
      if (!this.sessionGetUserInfo().token) {
        this.$emit('hideLoading')
        this.$root.Bus.$emit("showDialog", 0, true);
      } else {
        await this.checkAuth()
        console.log(this.checkVisible)
        if (!this.checkVisible) this.handleDownload()
      }
    },
    async checkAuth() {
      const result = await this.axios.get(`/user/getUserLoginInfo/1`).catch((res) => {})
      if (result) {
        this.$store.commit("addUserdata", result.data.data)
        if (!this.Authorization.authenticationInfoDTO || this.Authorization.authenticationInfoDTO.state !== 3 ) {
          console.log('未实名')
          this.checkVisible = true
          this.$emit('hideLoading')
        }
      } else {
        this.$emit('hideLoading')
        this.$message.warning('获取当前用户最新信息失败')
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// common/exportReport.vue